/* eslint-disable import/extensions,import/no-unresolved,no-console */
// https://www.npmjs.com/package/@newrelic/browser-agent#new-relic-browser-agent
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { ClientConfig } from 'client/configuration';

const consoleMethods = ['log', 'error', 'warn', 'info', 'debug', 'trace'];

export function initNewRelic(state) {
  if (!state.featureFlags.newrelic) return;

  const env = state.edmundsEnv;
  const { version, ecsServiceName } = state.venomVersion;
  const { session, id } = state.visitor;
  const { name, category } = state.pageContext.page;

  const options = ClientConfig.get('newrelic').browserConfig;

  const originalConsole = {};

  // preserving the original console to prevent the new relic from rewriting the methods
  // https://github.com/newrelic/newrelic-browser-agent/blob/93f0fd0076e1e1fcc2b353d766a7a95c0f524e76/src/features/logging/instrument/index.js#L25
  consoleMethods.forEach(method => {
    originalConsole[method] = console[method];
  });

  const agent = new BrowserAgent(options);

  // restoring
  consoleMethods.forEach(method => {
    console[method] = originalConsole[method];
  });

  agent.setCustomAttribute('version', version);
  agent.setCustomAttribute('session_id', session);
  agent.setCustomAttribute('visitor_id', id);
  agent.setCustomAttribute('page_name', name);
  agent.setCustomAttribute('page_category', category);
  agent.setCustomAttribute('env', env);
  agent.setCustomAttribute('ecs_service', ecsServiceName);

  if (state.featureFlags.catchUnhandledRejection) {
    agent.setErrorHandler(function ErrorHandler() {
      // Return feature flag based condition. If True - skip error, false - proceed
      return state.featureFlags.disableNewrelicJsErrors;
    });
  }
}
